import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import index from './views/index.vue'
// import check_robot from './views/check_robot.vue'
import forgot_login from './views/forgot_login.vue'
import myaccount from './views/myaccount.vue'
import rest_password from './views/rest_password.vue'
import signin from './views/signin.vue'
import signup from './views/signup.vue'
import starttest from './views/starttest.vue'
import test from './views/test.vue'
import result from './views/result.vue'
import test_history from './views/test_history.vue'
import managerAllUser from "./views/manager/allUser"
import managerHistory from "./views/manager/history"
import managerHome from "./views/manager/home"
import managerValidate from "./views/manager/validate"

Vue.use(Router);

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/frameIndex',
            name: 'index',
            component: index
        },
        // {
        //     path: '/check_robot',
        //     name: 'check_robot',
        //     component: {
        //         verify: check_robot
        //     }
        // },
        {
            path: '/forgot_login',
            name: 'forgot_login',
            component: forgot_login
        },
        {
            path: '/myaccount',
            name: 'myaccount',
            component: myaccount
        },
        {
            path: '/rest_password',
            name: 'rest_password',
            component: rest_password
        },
        {
            path: '/signin',
            name: 'signin',
            component: signin
        },
        {
            path: '/signup',
            name: 'signup',
            component: signup
        },
        {
            path: '/starttest',
            name: 'starttest',
            component: starttest
        },
        {
            path: '/test',
            name: 'test',
            // beforeEnter: (to, from, next) => {
            //     if (!store.state.isVerified) {
            //         next({path: '/check_robot', query: {toPath: '/test'}})
            //     } else
            //         next();
            // },
            component: test
        },
        {
            path: '/result/:id',
            props: true,
            name: 'result',
            component: result
        },
        {
            path: '/test_history',
            name: 'test_history',
            component: test_history
        },
        {
            path:'/manager',
            name:'manager',
            component:managerHome
        },
        {
            path:'/manager_validate',
            name:'managerValidate',
            component:managerValidate
        },
        {
            path:'/manager_all_user',
            name:'managerAllUser',
            component:managerAllUser
        },
        {
            path:'/manager_history/:email',
            props: true,
            name:'managerHistory',
            component:managerHistory
        },
        {
            path:'/manager_history',
            name:'managerHistory',
            component:managerHistory
        },
    ]
});
router.beforeEach((to, from, next) => {
    if (to.path === '/starttest' && store.state.user !== null) {
        next('/test');
    } else {
        next();
    }
})

export default router;
